import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Briefcase } from "lucide-react";

/**
 * Selector de marca reutilizable. Carga /api/brands y permite elegir una para scoping.
 * Si solo hay 1 marca, muestra el nombre sin dropdown.
 * onChange recibe el brand_id (o "" si elige "Automática").
 */
export default function BrandSelector({ value, onChange, testid = "brand-selector", allowAuto = true }) {
  const [brands, setBrands] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/brands")
      .then(({ data }) => {
        setBrands(data || []);
        if (!value && data?.length && !allowAuto) {
          const active = data.find((b) => b.is_active) || data[0];
          onChange?.(active.id);
        }
      })
      .finally(() => setLoading(false));
  }, []);

  if (loading) return null;
  if (brands.length === 0) return null;

  return (
    <label className="block" data-testid={testid}>
      <span className="font-mono-mark text-[10px] text-[#5C5C5C] flex items-center gap-1">
        <Briefcase className="w-3 h-3" /> MARCA
      </span>
      <select
        value={value || ""}
        onChange={(e) => onChange?.(e.target.value)}
        className="w-full mt-2 bg-white border border-[#0A0A0A] px-3 py-2 font-mono-data text-sm"
        data-testid={`${testid}-select`}
      >
        {allowAuto && <option value="">Automática (marca activa)</option>}
        {brands.map((b) => (
          <option key={b.id} value={b.id}>
            {b.brand_name}{b.is_active ? " · activa" : ""}
          </option>
        ))}
      </select>
    </label>
  );
}
